module.exports = __webpack_public_path__ + "static/media/rmdb_logo.08494abf.png";